import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { PaymentRequest } from './payment-request';
@Component({
  selector: 'cs-payment-request',
  standalone: false,
  templateUrl: './payment-request.component.html',
  styleUrls: ['./payment-request.component.scss']
})
export class PaymentRequestComponent implements OnInit, OnDestroy {
  public paymentRequests: Array<PaymentRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;

  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getPaymentRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.paymentRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: PaymentRequest): void {
    this.router.navigate(['/crm/customer-payments/requests/approval'], {
      queryParams: { paymentId: request.paymentId }
    });
    this.closeTodo.emit();
  }
}
